(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hn-halloween-product-coupons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hn-halloween-offers')) {
    customElements.define('hn-halloween-offers', class extends HTMLElement {
      connectedCallback() {
        if (this.onClick) return;
        this.onClick = this.handleClick.bind(this);
        this.onVisibility = () => this.checkExpiry();
        this.onOutside = (event) => {
          if (!this.contains(event.target)) this.closeOffers(false);
        };
        this.onKeydown = (event) => {
          if (event.key === 'Escape') this.closeOffers(true);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onOutside);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.checkExpiry();
        this.expiryTimer = window.setInterval(() => this.checkExpiry(), 60000);
      }
      checkExpiry() {
        if (Date.now() >= Date.parse(this.dataset.expires)) this.hidden = true;
      }
      closeOffers(returnFocus) {
        const dropdown = this.querySelector('details');
        if (!dropdown?.open) return;
        dropdown.open = false;
        if (returnFocus) dropdown.querySelector('summary').focus();
      }
      resetCopyFeedback() {
        window.clearTimeout(this.feedbackTimer);
        if (this.copyFeedback) this.copyFeedback.label.textContent = this.copyFeedback.originalLabel;
        this.copyFeedback = null;
        const hint = this.querySelector('[data-ticket-hint]');
        if (hint) {
          hint.textContent = '';
          hint.classList.remove('is-copy-error');
        }
      }
      cancelCopyAttempt() {
        const attempt = this.copyAttempt;
        if (!attempt) return;
        this.copyAttempt = null;
        attempt.cancelled = true;
        window.clearTimeout(attempt.timeout);
        delete attempt.button.dataset.copying;
        attempt.rejectWait(new Error('Copy cancelled'));
      }
      async handleClick(event) {
        const button = event.target.closest('[data-ticket-code]');
        if (!button || !this.contains(button) || button.dataset.copying) return;
        const code = button.dataset.ticketCode;
        const label = button.querySelector('[data-copy-label]');
        const codeLabel = button.closest('.hn-halloween-offers__ticket')?.querySelector('[data-ticket-label]');
        const hint = this.querySelector('[data-ticket-hint]');
        if (!label || !codeLabel || !hint) return;
        this.cancelCopyAttempt();
        this.resetCopyFeedback();
        const originalLabel = label.textContent;
        const attempt = { button, cancelled: false };
        this.copyAttempt = attempt;
        button.dataset.copying = 'true';
        let feedbackDuration = 3000;
        const timeout = new Promise((resolve, reject) => {
          attempt.rejectWait = reject;
          attempt.timeout = window.setTimeout(() => reject(new Error('Copy timed out')), 2000);
        });
        try {
          await Promise.race([navigator.clipboard.writeText(code), timeout]);
          if (attempt.cancelled || !this.isConnected) return;
          label.textContent = this.dataset.copySuccess;
          hint.textContent = code + ' · ' + this.dataset.copySuccess;
        } catch {
          if (attempt.cancelled || !this.isConnected) return;
          feedbackDuration = 6000;
          hint.textContent = this.dataset.copyError + ' ' + code;
          hint.classList.add('is-copy-error');
          try {
            const range = document.createRange();
            range.selectNodeContents(codeLabel);
            const selection = window.getSelection();
            if (selection) {
              selection.removeAllRanges();
              selection.addRange(range);
            }
          } catch {}
        } finally {
          window.clearTimeout(attempt.timeout);
          if (this.copyAttempt === attempt) {
            this.copyAttempt = null;
            delete button.dataset.copying;
          }
          if (!attempt.cancelled && this.isConnected) {
            this.copyFeedback = { label, originalLabel };
            this.feedbackTimer = window.setTimeout(() => this.resetCopyFeedback(), feedbackDuration);
          }
        }
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.clearInterval(this.expiryTimer);
        this.cancelCopyAttempt();
        this.resetCopyFeedback();
        this.onClick = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
